import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useToast } from '@/components/ui/toast';
import { settingsApi } from '@/features/settings/api';
import { DeleteAccountDialog } from './DeleteAccountDialog';

export function DangerZone() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const toast = useToast();

  const handleExport = async () => {
    setDownloading(true);
    try {
      await settingsApi.downloadExport();
      toast.show({ title: 'Exportação iniciada.', variant: 'success' });
    } catch (err) {
      toast.show({
        title: 'Erro ao exportar',
        description: err instanceof Error ? err.message : 'Tente novamente.',
        variant: 'error',
      });
    } finally {
      setDownloading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <Card>
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold">Exportar meus dados (LGPD)</h3>
          <p className="text-sm text-(--color-fg-muted)">
            Baixe um ZIP com todos os dados pessoais e fiscais vinculados à sua conta,
            em formato JSON legível.
          </p>
          <div>
            <Button onClick={handleExport} disabled={downloading}>
              {downloading ? 'Gerando ZIP…' : 'Baixar meus dados'}
            </Button>
          </div>
        </div>
      </Card>

      <Card className="border-(--color-error)/40">
        <div className="flex flex-col gap-2">
          <h3 className="font-semibold text-(--color-error)">Excluir conta</h3>
          <p className="text-sm text-(--color-fg-muted)">
            Após a confirmação, a conta é marcada para exclusão e o acesso é bloqueado.
            Os dados pessoais são apagados em 30 dias; dados fiscais permanecem por 5 anos
            conforme obrigação legal.
          </p>
          <div>
            <Button variant="destructive" onClick={() => setDialogOpen(true)}>
              Excluir minha conta
            </Button>
          </div>
        </div>
      </Card>

      <DeleteAccountDialog open={dialogOpen} onOpenChange={setDialogOpen} />
    </div>
  );
}
